export default class RequestPool {
  waiting = [];

  request(resolver, callback) {
    const waiting = this.waiting;

    waiting.push(callback);

    if (waiting.length === 1) {
      resolver((...args) => {
        while (waiting.length) {
          waiting.shift()?.(...args);
        }
      });

      return false;
    }
  }
}
